import { render } from "./Cartelas.vue?vue&type=template&id=b8a48a5c"
import script from "./Cartelas.vue?vue&type=script&lang=js"
export * from "./Cartelas.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__